export default function HWY_History() {
  this.init = () => {
    carouselTimeLine();
    openModal();
    closeModal();
    prevSlider();
    nextSlider();
  };
  const carouselTimeLine = () => {
    jQuery(document).ready(function ($) {
      var controller = new ScrollMagic.Controller();
      var totalWidth = 0;
      $(
        ".history-page-content-time-line .history-page-content-time-line-item "
      ).each(function () {
        totalWidth += $(this).width();
      });
      totalWidth =
        totalWidth +
        ($(
          ".history-page-content-time-line .history-page-content-time-line-item "
        ).length -
          1) *
          50 -
        ($(window).width() - 100) / 2;
      var wipeAnimation = new TimelineMax().to(
        ".history-page-content-time-line",
        1,
        { x: -totalWidth },
        { x: "0%", ease: Linear.easeNone }
      );
      var scene = new ScrollMagic.Scene({
        triggerElement: ".timeline-content",
        triggerHook: "onLeave",
        duration: "200%",
      })
        .setPin(".timeline-content")
        .setTween(wipeAnimation)
        .addTo(controller);
    });
  };
  const openModal = () => {
    jQuery(".history-page-content-time-line-item").click(function () {
      const data = jQuery(this).data("val");
      jQuery(".modal-history").addClass("opened");
      jQuery("body").css("overflow", "hidden");

      let periods = "";
      var images = "";
      if (data.now_toggle) {
        periods = "now";
      } else if (data.month) {
        periods = data.month + " - " + data.year;
      } else {
        periods = data.year;
      }
      if (data.images.image_gallery.length) {
        data.images.image_gallery.forEach(function (item) {
          images += `<div class="item image-item" style="background-image:url('${item.additional_images.url}')"></div>`;
        });
      }
      images += `<div class="item image-item" style="background-image:url('${data.images.featured_image.featured_image.url}')"></div>`;
      jQuery(".modal-history .history-info .time-periods h5").text(periods);
      jQuery(".modal-history .history-info .time-line-header h2").text(
        data.header
      );
      jQuery(".modal-history .history-info .time-line-description").html(
        data.description
      );
      const html =
        `<div class="history-image owl-carousel owl-theme">` +
        images +
        `</div>`;
      jQuery(".modal-history .modal-content").append(html);
      jQuery(document).ready(function ($) {
        $(".modal-history .history-image").owlCarousel({
          loop: false,
          nav: false,
          autoWidth: true,
          dots: true,
          items: 1,
        });
      });
    });
  };
  const closeModal = () => {
    jQuery(".btn-close").click(function () {
      jQuery(".modal-history").removeClass("opened");
      jQuery("body").css("overflow", "auto");
      jQuery(".modal-history .modal-content .history-image").remove();
    });
  };
  const prevSlider = () => {
    jQuery(".history-page-content-control .btn-prev").click(function () {
      jQuery("html, body").animate(
        {
          scrollTop: "-=100px",
        },
        500
      );
    });
  };
  const nextSlider = () => {
    jQuery(".history-page-content-control .btn-next").click(function () {
      jQuery("html, body").animate(
        {
          scrollTop: "+=100px",
        },
        500
      );
    });
  };
}
